exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".App {\n  display: flex;\n  text-align: center;\n}\n\ninput:focus,\ntextarea:focus {\n  outline: 0px solid white;\n}\n", ""]);

// exports
